const EXPORT_DATA_OPTIONS_NAMES = {
  EXPORT: 'Export.csv',
  EXPORT_CSV_XLSX: 'Export (csv/xlsx)',
  EXPORT_CSV: 'Export CSV',
  EXPORT_XLSX: 'Export Excel',
  PRINT: 'Print',
  OPEN_ASSIGNMENTS: 'Export Open Assignments',
  REVISITS_NEEDED: 'Export Revisits Needed',
  CAMPAIGN_LIST: 'Export Campaign List',
};

const EXPORT_DATA_OPTIONS = [
  {
    label: EXPORT_DATA_OPTIONS_NAMES.EXPORT,
    value: EXPORT_DATA_OPTIONS_NAMES.EXPORT,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.PRINT,
    value: EXPORT_DATA_OPTIONS_NAMES.PRINT,
  },
];

const EXPORT_DATA_OPTIONS_WITH_XLSX = [
  {
    label: EXPORT_DATA_OPTIONS_NAMES.EXPORT_CSV_XLSX,
    value: EXPORT_DATA_OPTIONS_NAMES.EXPORT_CSV_XLSX,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.PRINT,
    value: EXPORT_DATA_OPTIONS_NAMES.PRINT,
  },
];

const EXPORT_DATA_OPTIONS_CSV_AND_XLSX = [
  {
    label: EXPORT_DATA_OPTIONS_NAMES.EXPORT_CSV,
    value: EXPORT_DATA_OPTIONS_NAMES.EXPORT_CSV,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.EXPORT_XLSX,
    value: EXPORT_DATA_OPTIONS_NAMES.EXPORT_XLSX,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.PRINT,
    value: EXPORT_DATA_OPTIONS_NAMES.PRINT,
  },
];

const EXPORT_CAMPAING_LIST_DATA_OPTIONS = [
  {
    label: EXPORT_DATA_OPTIONS_NAMES.CAMPAIGN_LIST,
    value: EXPORT_DATA_OPTIONS_NAMES.CAMPAIGN_LIST,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.PRINT,
    value: EXPORT_DATA_OPTIONS_NAMES.PRINT,
  },
];

const EXPORT_RETAILERS_VISITS_DATA_OPTIONS = [
  {
    label: EXPORT_DATA_OPTIONS_NAMES.OPEN_ASSIGNMENTS,
    value: EXPORT_DATA_OPTIONS_NAMES.OPEN_ASSIGNMENTS,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.REVISITS_NEEDED,
    value: EXPORT_DATA_OPTIONS_NAMES.REVISITS_NEEDED,
  },
  {
    label: EXPORT_DATA_OPTIONS_NAMES.PRINT,
    value: EXPORT_DATA_OPTIONS_NAMES.PRINT,
  },
];

export {
  EXPORT_DATA_OPTIONS_NAMES,
  EXPORT_DATA_OPTIONS,
  EXPORT_DATA_OPTIONS_WITH_XLSX,
  EXPORT_DATA_OPTIONS_CSV_AND_XLSX,
  EXPORT_RETAILERS_VISITS_DATA_OPTIONS,
  EXPORT_CAMPAING_LIST_DATA_OPTIONS,
};
